'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".LoadingDots-module_container__P0jJR{height:1rem}.LoadingDots-module_dot__ywK0s{animation-duration:1.3s;animation-iteration-count:infinite;animation-name:LoadingDots-module_wave__vwGYt;animation-timing-function:linear;background:#adb0ba;border-radius:50%;display:inline-block;height:.5rem;margin-right:3px;width:.5rem}.LoadingDots-module_dot__ywK0s:nth-child(2){animation-delay:-1.1s;opacity:.4}.LoadingDots-module_dot__ywK0s:nth-child(3){animation-delay:-.9s;opacity:.2}@keyframes LoadingDots-module_wave__vwGYt{0%,60%,to{transform:none}30%{transform:translateY(-15px)}}";
var styles = {"container":"LoadingDots-module_container__P0jJR","dot":"LoadingDots-module_dot__ywK0s","wave":"LoadingDots-module_wave__vwGYt"};
styleInject["default"](css_248z, '8f24c3d1-d6b9-404c-a9fd-a85aefd86ec8');

exports["default"] = styles;
